import { createAction, props } from '@ngrx/store';
import { Formation } from '../../model/formation.model';
import { Occurrence } from '../../model/occurrence.model';

// Load formations list
export const LoadFormations = createAction(
  '[Formation] Load Formations',
  props<{ studentId?: number }>()
);

export const LoadFormationsSuccess = createAction(
  '[Formation] Load Formations Success',
  props<{ formations: Formation[] }>()
);

export const LoadFormationsFailure = createAction(
  '[Formation] Load Formations Failure',
  props<{ error: string }>()
);

// Select current formation
export const SelectFormation = createAction(
  '[Formation] Select Formation',
  props<{ formation: Formation }>()
);

export const ClearSelectedFormation = createAction(
  '[Formation] Clear Selected Formation'
);

// Load formation detail
export const LoadFormationDetail = createAction(
  '[Formation] Load Formation Detail',
  props<{ formationId: number }>()
);

export const LoadFormationDetailSuccess = createAction(
  '[Formation] Load Formation Detail Success',
  props<{ formation: Formation }>()
);

export const LoadFormationDetailFailure = createAction(
  '[Formation] Load Formation Detail Failure',
  props<{ error: string }>()
);

// Load next occurrence
export const LoadNextOccurrence = createAction(
  '[Formation] Load Next Occurrence',
  props<{ formationId: number }>()
);

export const LoadNextOccurrenceSuccess = createAction(
  '[Formation] Load Next Occurrence Success',
  props<{ occurrence: Occurrence }>()
);

export const LoadNextOccurrenceFailure = createAction(
  '[Formation] Load Next Occurrence Failure',
  props<{ error: string }>()
);

// Update formation
export const UpdateFormation = createAction(
  '[Formation] Update Formation',
  props<{ formationUrl: string; params: Partial<Formation> }>()
);

export const UpdateFormationSuccess = createAction(
  '[Formation] Update Formation Success',
  props<{ formation: Formation }>()
);

export const UpdateFormationFailure = createAction(
  '[Formation] Update Formation Failure',
  props<{ error: string }>()
);

// Clear all formations state
export const ClearFormationsState = createAction(
  '[Formation] Clear Formations State'
);
